import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Globals } from '../common/Globals';
import { template } from '@angular/core/src/render3';
import { DriverModel } from '../common/models/dashboard.models';
import { Observable } from 'rxjs';
import { DriverTableRecord, HeaderModel } from '../common/models/header.models';
import { FuelBid } from '../common/models/fuel-bid.models';

@Injectable()
export class DashboardService {

    constructor(private httpClient: HttpClient) {

    }

    updateDeviceName(deviceId: string, deviceName: string) {
        return this.httpClient.patch(Globals.webUrl + `device/${deviceId}/name/${deviceName}`, null);
    }

    updateTankName(deviceId: string, tank: string, tankName: string) {
        return this.httpClient.patch(Globals.webUrl + `device/${deviceId}/tank/${tank}/name/${tankName}`, null);
    }

    updateDeviceSort(username: string, xml: string, index: number, changeGroupTime: number) {
        let parameters = new HttpParams()
            .append('username', `${username}`);
        //return this.httpClient.patch(Globals.webUrl + `username/${username}/xml/${xml}/index/${index}`, null);
        var body = JSON.stringify({ xml: xml, index: index, changeGroupTime: changeGroupTime });
        return this.httpClient.post(Globals.webUrl + `device/sort-device`, { xml: xml, index: index, changeGroupTime: changeGroupTime }, { params: parameters });
    }

    getUserDevices(companyId: string, parentId: string, childId: string) {
        const temp = new Date();
        const month = temp.getMonth() + 1;
        const date = `${temp.getFullYear()}-${month < 10 ? ('0' + month) : month}-${temp.getDate()} ${temp.getHours()}:${temp.getMinutes()}:00`;
        return this.httpClient.get(Globals.webUrl + 'device/list/' + date + '/' + companyId + '/' + parentId + '/' + childId);
    }

    getDeviceDetails(deviceId: string) {
        return this.httpClient.get(Globals.webUrl + 'device/' + deviceId);
    }

    getDevicePsi(deviceId: string) {
        return this.httpClient.get(Globals.webUrl + 'device/' + deviceId + '/psi');
    }

    getTemplates() {
        return this.httpClient.get(Globals.webUrl + 'device/template');
    }

    getTemplateById(templateId: string) {
        return this.httpClient.get(Globals.webUrl + 'device/template/' + templateId);
    }

    getGraph(gsmId: string, tankName: string, fromDate: string, toDate: string) {
        const temp = new Date();
        const month = temp.getMonth() + 1;
        const date = `${temp.getFullYear()}-${month < 10 ? ('0' + month) : month}-${temp.getDate()} ${temp.getHours()}:${temp.getMinutes()}:00`;
        console.log(tankName);
        return this.httpClient.get(Globals.webUrl + 'graph/' + gsmId + '/date/' + date + '/tank/' + tankName + '/fromDate/' + fromDate + '/toDate/' + toDate);
    }

    exportToCsv(gsmId: string, fromDate: string, toDate: string) {
        const temp = new Date();
        const month = temp.getMonth() + 1;
        const date = `${temp.getFullYear()}-${month < 10 ? ('0' + month) : month}-${temp.getDate()} ${temp.getHours()}:${temp.getMinutes()}:00`;
        return this.httpClient.get(Globals.webUrl + 'device/' + gsmId + '/export/' + date + '/from/' + fromDate + '/to/' + toDate);
    }

    updateCoordinates(deviceId: string, latitude: string, longitude: string) {
        return this.httpClient.patch(Globals.webUrl + `device/${deviceId}/latitude/${latitude}/longitude/${longitude}`, null);
    }

    updateDeviceData(data: any, deviceId: string) {
        return this.httpClient.post(Globals.webUrl + `device/${deviceId}`, data);
    }

    updatePsiData(data: any, deviceId: string) {
        return this.httpClient.post(Globals.webUrl + `device/${deviceId}/psi`, data);
    }

    updateDeviceDescription(deviceId: string, deviceDescription: string) {

        let parameters = new HttpParams()
            .append('deviceId', `${deviceId}`);

        return this.httpClient.post(Globals.webUrl + `device/description`, { deviceDescription: deviceDescription }, { params: parameters });

        //return this.httpClient.patch(Globals.webUrl + `device/${deviceId}/description/${encodeURIComponent(deviceDescription)}`, null);

    }

    updateDeviceGroup(deviceId: string, groupId: string) {
        return this.httpClient.patch(Globals.webUrl + `device/${deviceId}/groupId/${groupId}`, null);
    }


    getTreeList() {
        var companyId = localStorage.getItem('getCompanyId');
        return this.httpClient.get(Globals.webUrl + `device/tree/companyId/` + companyId);
    }

    getAllDrivers(username: string) {
        return this.httpClient.get(Globals.webUrl + `driver/drivers?user=${username}`)
    }

    createDriver(username: string, driver: DriverModel) {
        return this.httpClient.post(Globals.webUrl + `driver/driver/create?user=${username}`, driver)
    }

    updateDriver(driver: DriverModel) {
        return this.httpClient.post(Globals.webUrl + `driver/driver/update`, driver)
    }

    getDates(driverId: string): Observable<any> {
        return this.httpClient.get(Globals.webUrl + `driver/dates?userId=${driverId}`);
    }

    checkHeadersByDate(date: string, driverId: string): Observable<any> {
        return this.httpClient.get(Globals.webUrl + `driver/headers?userId=${driverId}&&date=${date}`);
    }

    getAreaDetails(date: string, driverId: string): Observable<any> {
        return this.httpClient.get(Globals.webUrl + `driver/area?userId=${driverId}&&date=${date}`);
    }

    createHeaderRecord(header: any, headerId: string): Observable<any> {
        return this.httpClient.post(Globals.webUrl + `driver/headers/create-record?headerId=${headerId}`, header);
    }

    updateHeaderRecord(header: DriverTableRecord): Observable<any> {
        return this.httpClient.post(Globals.webUrl + `driver/headers/update`, header);
    }
    deleteHeaderRecord(header: DriverTableRecord): Observable<any> {
        return this.httpClient.post(Globals.webUrl + `driver/headers/delete`, header);
    }

    saveDriverHeader(header: HeaderModel): Observable<any> {
        return this.httpClient.post(Globals.webUrl + `driver/headers/create-header`, header);
    }

    getFuelBids(deviceId: string): Observable<any>{
        return this.httpClient.get(Globals.webUrl + `device/fuelBid?deviceId=${deviceId}`);

    }
    getFuelLocation(deviceId: string): Observable<any>{
        return this.httpClient.get(Globals.webUrl + `device/fuelLocation?deviceId=${deviceId}`);

    }

    sendFuelMail(model : FuelBid) :Observable<any>{
        return this.httpClient.post(Globals.webUrl + `device/fuel/mail`, model);
    }

}